const generate_color_map = function (array_name, array_color, text) {
  const name_array = array_name.map((d) => (d === null ? "text" : d));
  let result = [],
    i,
    l = Math.min(name_array.length, array_color.length),
    circle_color;
  for (i = 0; i < l; i++) {
    result.push(name_array[i], array_color[i]);
  }
  if (array_color.length <= name_array.length) {
    array_color.push("#fff");
  }
  result.push(...name_array.slice(l), ...array_color.slice(l));
  circle_color = ["match", ["get", text]];
  circle_color = circle_color.concat(result);
  return circle_color;
};
export default generate_color_map;
